module.exports = __webpack_public_path__ + "static/media/BH.82818ede.svg";